import React, { Component } from 'react';
import ExtendSessionHandler from 'smc-extendsession';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';

class SessionHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        extendSession: {
          warningMessage: i18n.message('extendSession.extendSession.warningMessage'),
          logoutMessage: i18n.message('extendSession.extendSession.logoutMessage'),
          extendSessionBtnTxt: i18n.message('extendSession.extendSession.extendSessionBtnTxt'),
        },
      },
    };
  }

  render() {
    if (!Page.isLoggedIn()) {
      return null;
    }
    return (
      <ExtendSessionHandler
        reLoginURL="/signin"
        extendSessionURL="/smarthelp/extendSession"
        warningMessage={this.state.data.extendSession.warningMessage}
        logoutMessage={this.state.data.extendSession.logoutMessage}
        extendSessionBtnTxt={this.state.data.extendSession.extendSessionBtnTxt}
      />
    );
  }
}

export default SessionHandler;
